import { mix, rgba } from 'polished';

import {
  base,
  type BaseFgShades,
  interpolateRecord,
  type PaletteShape
} from './palette';

export const fgShades: BaseFgShades = {
  '100': 0,
  '200': 0.026,
  '300': 0.056,
  '400': 0.077,
  '500': 0.103,
  '600': 0.129,
  '700': 0.172,
  '800': 0.249,
  '900': 0.386,
  '1000': 0.446,
  '1100': 0.592,
  '1200': 0.923
};

const fg = interpolateRecord(fgShades, 'fg', v =>
  mix(v, base.violetTopaz, '#EAEAEA')
);

const fgA = interpolateRecord(fgShades, 'fgA', v => rgba(base.violetTopaz, v));

export const palette: PaletteShape = {
  ...base,
  ...fg,
  ...fgA,
  fgLoud: base.obsidian
};
